import { render, staticRenderFns } from "./Payfess.vue?vue&type=template&id=48492abd&scoped=true&"
import script from "./Payfess.vue?vue&type=script&lang=js&"
export * from "./Payfess.vue?vue&type=script&lang=js&"
import style0 from "./Payfess.vue?vue&type=style&index=0&id=48492abd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48492abd",
  null
  
)

export default component.exports